import { WeatherSettings } from './Settings/WeatherSettings';
import { BestSellersSettings } from './Settings/BestSellersSettings';
import { ProductPromotionSettings } from './Settings/ProductPromotionSettings';

export const smartPromotionsMetadata = {
    weather: {
        imgUrl: 'https://s3-eu-west-1.amazonaws.com/assets.paidit.common-bucket/Weather.png',
        title: 'smartPromotions.weather.title',
        description: 'smartPromotions.weather.description',
        Settings: WeatherSettings,
        options: {
            type: 'upsell',
            hotWeather: { from: '21', to: '' },
            coldWeather: { from: '', to: '20' }
        },
        isDisabled: true
    },
    bestsellers: {
        imgUrl: 'https://s3-eu-west-1.amazonaws.com/assets.paidit.common-bucket/BestSeller.png',
        title: 'smartPromotions.bestsellers.title',
        description: 'smartPromotions.bestsellers.description',
        Settings: BestSellersSettings,
        options: {
            type: 'primary',
            top: '5',
            minPrice: '5'
        },
        isDisabled: true
    },
    promotion: {
        imgUrl: 'https://images.squarespace-cdn.com/content/v1/5cb532c8fae5d50001f44c3f/1555380140882-QLAEBWFQ8DIG4L50Y9VF/ke17ZwdGBToddI8pDm48kNvT88LknE-K9M4pGNO0Iqd7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z5QPOohDIaIeljMHgDF5CVlOqpeNLcJ80NK65_fV7S1USOFn4xF8vTWDNAUBm5ducQhX-V3oVjSmr829Rco4W2Uo49ZdOtO_QXox0_W7i2zEA/Asana+Color+Gradient+Gradient+-+htmlcolors.com.png',
        title: 'smartPromotions.promotion.title',
        description: 'smartPromotions.promotion.description',
        Settings: ProductPromotionSettings,
        options: {
            type: 'upsell',
            startDate: null,
            endDate: null,
            itemId: '',
            price: '',
            bannerUrl: '',
            bannerGuid: ''
        },
        isDisabled: true
    }
};